import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/participants.action'
import addProfileBulkAction from 'api/administration/participants/AddProfilesBulkAction'

async function addProfiles(ids: number[], profilesIds: number[]) {
  return await addProfileBulkAction(ids, profilesIds)
}

function* participantsAddProfilesEffectSaga(action: any) {
  try {
    const { ids, profilesIds, listConfig } = action.payload
    yield call(addProfiles, ids, profilesIds)
    yield put(fromActions.Actions.participantsProfilesList(listConfig))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* participantsAddProfilesWatcherSaga() {
  yield takeLatest(fromActions.ADD_PROFILES_BULK_ACTION, participantsAddProfilesEffectSaga)
}
